import { Box, Grid } from "@mui/material";
import { useStyles } from "./basket-content-style";
import { useTranslation } from "react-i18next";
import { BookingJourney_Paths } from "utils/constants";
import { useNavigate } from "react-router-dom";
import { MobileDrawer } from "components";
import { BasketContent } from "./basket-content";
import { BasketAction } from "./basket-action";
import { ProductBasket } from "store/bookingJourney";
import { enableInstructionBanner } from "utils/helpers";
import { InstructionBanner } from "../nav-banner/instruction-banner";

type ContentProps = {
  basketContentDrawerOpen: boolean;
  setbasketContentDrawerOpen: (smallDrawer: boolean) => void;
  products: ProductBasket[];
  setMobileProfileDrawerOpen?: (open: boolean) => void;
};
export const BasketContentMobile: React.FC<ContentProps> = ({
  basketContentDrawerOpen,
  setbasketContentDrawerOpen,
  products,
  setMobileProfileDrawerOpen,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = (path: string) => {
    if (location.pathname !== path) {
      navigate(path);
    }
    setbasketContentDrawerOpen(false);
  };

  return (
    <MobileDrawer isOpen={basketContentDrawerOpen} onVisibilityChange={setbasketContentDrawerOpen}>
      {products?.length > 0 ? (
        <>
          <Box role="alert" aria-atomic="true" className={classes.dialogTitleMobile}>
            {t("your_basket")}
          </Box>
          <Grid>
            <BasketContent products={products}></BasketContent>
            {enableInstructionBanner() && (
              <InstructionBanner message={t("basket_reminder_message")}></InstructionBanner>
            )}
            <BasketAction
              products={products}
              handleClose={null}
              setbasketContentDrawerOpen={() => {
                setMobileProfileDrawerOpen(false);
                handleClick(BookingJourney_Paths.Summary);
              }}
              isMobile={true}
            ></BasketAction>
          </Grid>
        </>
      ) : (
        t("empty_basket")
      )}
    </MobileDrawer>
  );
};
